import helpers from '../../util/helpers';

const searchLocations = () => {
  jQuery(document).ready(function($) {
    // Locations autocomplete
    const locationSearch = $('input.location-search');
    if (locationSearch.length) {
      locationSearch.each(function() {
        const _this = $(this);
        const clearButton = _this.siblings('.clear-button');

        const options = {
          minimumInputLength: 0,
          maxResults: 20,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 2,
        };

        _this.rsdAutocomplete(options);

        if (_this.val().length === 0) {
          clearButton.hide();
        }

        clearButton.on('click', function() {
          _this.val('');
          _this.trigger('input');
        });
      });

      // Save input to cookie
      locationSearch.on('input', function() {
        const _this = $(this);
        const clearButton = _this.siblings('.clear-button');

        if (_this.val().length === 0) {
          clearButton.hide();
        } else {
          clearButton.show();
        }

        if (_this.data('cookie-location') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-location'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);
        const clearButton = _this.siblings('.clear-button');

        clearButton.show();

        if (_this.data('cookie-location')) {
          helpers.docCookies.setItem(_this.data('cookie-location'), _this.val(), 1500, '/');
        }
      });

      // Populate recent search into cookie, preparing for search results page
      $(document).on('click', '.recent-search[href="#"]', function(e) {
        e.preventDefault();

        const thisRecentSearch = $(this);

        if (thisRecentSearch.data('cookie-location')) {
          locationSearch.val(thisRecentSearch.data('recent-location'));

          helpers.docCookies.setItem(thisRecentSearch.data('cookie-location'), thisRecentSearch.data('recent-location'), 1500, '/');
        }

        // location.href = thisRecentSearch.closest('form').attr('action'); // Do not "Submit" the form, cause it may confuse
      });
    }
  });
};

export default searchLocations;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchLocations.js